module.exports = "/_next/static/images/uzuna_menu_tea-82909f3d34d10b1ee4377a40df73f466.jpg";